import { render, staticRenderFns } from "./ChatBotForm.vue?vue&type=template&id=729083bc&scoped=true&"
import script from "./ChatBotForm.vue?vue&type=script&lang=js&"
export * from "./ChatBotForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotForm.vue?vue&type=style&index=0&id=729083bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729083bc",
  null
  
)

export default component.exports